import { render } from "./AddButton.vue?vue&type=template&id=407834c4&ts=true"
import script from "./AddButton.vue?vue&type=script&lang=ts"
export * from "./AddButton.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__